import React from 'react'
import '@hotwired/turbo-rails'
import { createRoot } from 'react-dom/client'
import { ErrorLogger } from '@byscott-io/issuesbyscott_client'
import { configure as configureMetrics, track as metricsTrack } from '@byscott-io/metricsbyscott-web'
import { storage, configureAuth } from '@byscott-io/corebyscott'
import App from './src/components/App'

// Set up client-side error reporting
if (window.ENV?.ISSUESBYSCOTT_API_URL && window.ENV?.ISSUESBYSCOTT_API_KEY) {
  ErrorLogger.configure({
    apiUrl: window.ENV.ISSUESBYSCOTT_API_URL,
    apiKey: window.ENV.ISSUESBYSCOTT_API_KEY,
    environment: window.ENV.RAILS_ENV || 'production',
    enabled: window.ENV.RAILS_ENV === 'production',
    commitSha: window.ENV?.COMMIT_SHA,
    onError: (eventName, properties) => metricsTrack(eventName, properties),
  });
  ErrorLogger.setupGlobalHandler();

  // setupGlobalHandler catches window.onerror, which React render errors do NOT
  // reach -- React swallows them and unmounts the tree. Core's ErrorBoundary is
  // what sees those, and it reports through core's own config, so point it here.
  configureAuth({
    onError: (error, info) =>
      ErrorLogger.report(error, { componentStack: info?.componentStack }),
  });
}

// Set up metrics tracking
if (window.ENV?.METRICSBYSCOTT_API_URL && window.ENV?.METRICSBYSCOTT_API_KEY) {
  configureMetrics({
    apiUrl: window.ENV.METRICSBYSCOTT_API_URL,
    apiKey: window.ENV.METRICSBYSCOTT_API_KEY,
    appName: 'prioritize-plus',
    autoClickTrackingAnonymous: true,
    enabled: window.ENV.RAILS_ENV === 'production',
    // Seed identity synchronously from cached auth so a logged-in user's first
    // page_view is attributed without waiting for /me; member_id fills in via
    // useMetricsIdentity once auth resolves.
    userId: storage.getCurrentUserId() || undefined,
    containerId: storage.getCurrentContainerId() || undefined,
  })
}

function initializeApp() {
  const container = document.getElementById('app');
  if (!container) {
    console.error('App container not found!')
    return
  }
  
  const data = JSON.parse(container.getAttribute('data-props') || '{}')
  const root = createRoot(container);
  root.render(<App {...data} />);
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp)
} else {
  initializeApp()
}

